import api from '../utils/api';
import qs from '../utils/qs';

export const getProfile = async (data) => {
    try {
        const response = await api.get(`/admin/profile`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const editProfile = async (data) => {
    try {
        const response = await api.put(`/admin/profile`, data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message };
    }
}